import React from "react";

export const tableData = [
  {
    id: "1",
    name: "Product Menu",
    status: <i className="fa fa-circle font-success f-12" />,
    creat_on: "2022-04-18T00:00:00",
  },
  {
    id: "2",
    name: "Category Menu",
    status: <i className="fa fa-circle font-warning f-12" />,
    creat_on: "2022-04-18T00:00:00",
  },
  {
    id: "3",
    name: "Subcategory Menu",
    status: <i className="fa fa-circle font-success f-12" />,
    creat_on: "2022-04-18T00:00:00",
  },
  {
    id: "4",
    name: "Sales  Menu",
    status: <i className="fa fa-circle font-danger f-12" />,
    creat_on: "2022-04-18T00:00:00",
  },
  {
    id: "5",
    name: "Vendor Menu",
    status: <i className="fa fa-circle font-success f-12" />,
    creat_on: "2022-04-18T00:00:00",
  },
  {
    id: "6",
    name: "Category Menu",
    status: <i className="fa fa-circle font-warning f-12" />,
    creat_on: "2022-04-18T00:00:00",
  },
];

export const basicDataTable = [
  {
    id: 1,
    icon: "alert-triangle",
    status: "No Signal",
    signalName: "Astrid: NE Shared managed",
    security: "Medium",
    stage: "Triaged",
    schedule: "0.33",
    bgClass: "bg-light-primary font-primary",
    teamLead: "Chase Nguyen",
  },
  {
    id: 2,
    icon: "alert-triangle",
    status: "Offline",
    signalName: "Cosmo: prod shared ares",
    security: "Huge",
    stage: "Triaged",
    schedule: "0.39",
    bgClass: "bg-light-danger font-danger",
    teamLead: "Brie Furman",
  },
  {
    id: 3,
    icon: "alert-circle",
    status: "Online",
    signalName: "Phoenix: prod shared lyra-lists",
    security: "Minor",
    stage: "No Triaged",
    schedule: "3.12",
    bgClass: "bg-light-success font-success",
    teamLead: "Jeremy Lake",
  },
  {
    id: 4,
    icon: "check-circle",
    status: "No Signal",
    signalName: "Astrid: NE Shared managed",
    security: "Negligible",
    stage: "triaged",
    schedule: "13.18",
    bgClass: "bg-light-primary font-primary",
    teamLead: "Angelica Howards",
  },
  {
    id: 5,
    icon: "check-circle",
    status: "Online",
    signalName: "Astrid: NE Shared managed",
    security: "Negligible",
    stage: "triaged",
    schedule: "5.33",
    bgClass: "bg-light-success font-success",
    teamLead: "Diane Okuma",
  },
];

export const tableData3 = [
  {
    id: 1,
    img: "/assets/images/avtar/boy.png",
    firstName: "Ram Jacob",
    lastName: "Wolfe",
    userName: "RamJacob@twitter",
    role: "Developer",
    company: "Apple Inc.",
    language: "Php",
    badgeClass: "badge-light-primary",
    credit: "$3500.00",
    borderColor: "border-bottom-secondary",
    country: "IND",
  },
  {
    id: 2,
    img: "/assets/images/avtar/man.png",
    firstName: "John Deo",
    lastName: "Gummer",
    userName: "JohnDeo@twitter",
    role: "Designer",
    company: "Hewlett packard",
    language: "Html",
    badgeClass: "badge-light-success",
    credit: "$2400.00",
    borderColor: "border-bottom-success",
    country: "US",
  },
  {
    id: 3,
    img: "/assets/images/avtar/girl.png",
    firstName: "Elana John",
    lastName: "Cazale",
    userName: "ElanaJohn@twitter",
    role: "Designer",
    company: "Microsoft",
    language: "Pug",
    badgeClass: "badge-light-primary",
    credit: "$2560.00",
    borderColor: "border-bottom-info",
    country: "UK",
  },
  {
    id: 4,
    img: "/assets/images/avtar/chat-user-1.png",
    firstName: "Meryl Streep",
    lastName: "Roberts",
    userName: "MerylStreep@twitter",
    role: "Developer",
    company: "Tata Ltd.",
    language: "React",
    badgeClass: "badge-light-success",
    credit: "$1870.00",
    borderColor: "border-bottom-warning",
    country: "IDN",
  },
  {
    id: 5,
    img: "/assets/images/avtar/woman.png",
    firstName: "Emma Stone",
    lastName: "Stone",
    userName: "EmmaStone@twitter",
    role: "Developer",
    company: "Wipro Ltd.",
    badgeClass: "badge-light-primary",
    language: "Vue",
    credit: "$4580.00",
    borderColor: "border-bottom-danger",
    country: "IRN",
  },
  {
    id: 6,
    img: "/assets/images/avtar/girl.png",
    firstName: "Eliana Jons",
    lastName: "Jons",
    userName: "ElianaJons@twitter",
    role: "Developer",
    company: "Info Ltd.",
    badgeClass: "badge-light-primary",
    language: "Vue",
    credit: "$4580.00",
    borderColor: "border-bottom-light",
    country: "IRN",
  },
];

export const inverse = [
  {
    id: 1,
    firstName: "Stephan",
    lastName: "Laiten",
    office: "Tokyo",
    role: "Accountant",
    salary: "$2100.00",
    age: 20,
    join: "21/01/2023",
  },
  {
    id: 2,
    firstName: "Fay",
    lastName: "Van Damme",
    office: "London",
    role: "CEO",
    salary: "$1420.00",
    age: 22,
    join: "14/02/2023",
  },
  {
    id: 3,
    firstName: "Brevin",
    lastName: "Oleveria",
    office: "New York",
    role: "Software Engineer",
    salary: "$1340.00",
    age: 18,
    join: "04/06/2022",
  },
  {
    id: 4,
    firstName: "Regina",
    lastName: "Ottandy",
    office: "France",
    role: "Pre-sale Support",
    salary: "$3400.00",
    age: 25,
    join: "10/08/2022",
  },
  {
    id: 5,
    firstName: "Vani",
    lastName: "Shah",
    office: "Los Angeles",
    role: "Senior Developer",
    salary: "$3500.00",
    age: 28,
    join: "23/07/2022",
  },
];

export const contextual = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "danger",
  "light",
  "active",
];
export const textOrBgUtilities = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "danger",
  "light",
];

export const table2 = [
  {
    id: 1,
    firstName: "Mark",
    name: "Elana Robbert",
    email: "ElanaRob@gmail.com",
    lastName: "Otto",
    exp: "1 Year",
    sex: "Male",
    contact: "+91 9789887777",
    userName: "Mark@twitter",
    age: "28",
    dessert: "KitKat",
    calories: "518",
    fat: "26",
    price: "20",
  },
  {
    id: 2,
    firstName: "Elana",
    name: "Stiphen Deo",
    email: "Stiphen@yahoo.com",
    lastName: "Thornton",
    exp: "6 Month",
    sex: "Female",
    contact: "+91 9874563210",
    userName: "Elana@twitter",
    age: "22",
    dessert: "Donut",
    calories: "452",
    fat: "25",
    price: "80",
  },
  {
    id: 3,
    firstName: "Larry",
    name: "Genelia Ottre",
    email: "Genelia@gmail.com",
    lastName: "Otthe Birdto",
    exp: "2 Days",
    sex: "Male",
    contact: "+91 8794562135",
    userName: "Larry@twitter",
    age: "24",
    dessert: "Eclair",
    calories: "262",
    fat: "16",
    price: "10",
  },
];

export const breckpointSpecific = [
  {
    id: 1,
    data: ["Iphone X Grey", "C12345", "$12550", "1", "$12550"],
  },
  {
    id: 2,
    data: ["Titan Watch", "A14725", "$120", "2", "$240"],
  },
  {
    id: 3,
    data: ["Apple Airpods", "B54213", "$210", "1", "$210"],
  },
];

export const areaTableData = [
  // {
  //   camera: '1',
  //   date: '2024-04-02',
  //   time: '10:20 AM',
  //   VioSeverity: 'High',
  //   status: 'Active',
  //   module: 'Helmet Module',
  //   violation: 'Helmet',
  //   violationArea: 'Gate #01',
  //   image: 'https://plus.unsplash.com/premium_photo-1663040345603-fe0968d5d514?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Y29uc3RydWN0aW9uJTIwd29ya2VyfGVufDB8fDB8fHww', // Replace with the actual image path
  // },
  // // Add more objects here if you want more rows
  // {
  //   camera: '3',
  //   date: '2024-09-14',
  //   time: '10:20 AM',
  //   VioSeverity: 'Medium',
  //   status: 'Active',
  //   module: 'Helmet Module',
  //   violation: 'Helmet',
  //   violationArea: '',
  //   image: 'https://plus.unsplash.com/premium_photo-1663040345603-fe0968d5d514?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Y29uc3RydWN0aW9uJTIwd29ya2VyfGVufDB8fDB8fHww', // Replace with the actual image path
  // },
  {
    camera: "4",
    date: "2024-09-13",
    time: "10:20 AM",
    VioSeverity: "High",
    status: "Active",
    module: "Emergency Exit",
    violation: "Blockage",
    violationArea: "",
    image:
      "https://plus.unsplash.com/premium_photo-1663040345603-fe0968d5d514?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Y29uc3RydWN0aW9uJTIwd29ya2VyfGVufDB8fDB8fHww", // Replace with the actual image path
  },
  {
    camera: "5",
    date: "2024-09-12",
    time: "10:20 AM",
    VioSeverity: "Low",
    status: "In Active",
    module: "Machine Guard",
    violation: "Door Open",
    violationArea: "",
    image:
      "https://plus.unsplash.com/premium_photo-1663040345603-fe0968d5d514?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Y29uc3RydWN0aW9uJTIwd29ya2VyfGVufDB8fDB8fHww", // Replace with the actual image path
  },
];

export const areaTableDataALerts = [
  {
    camera: "4",
    date: "2024-09-13",
    time: "10:20 AM",
    VioSeverity: "High",
    status: "Active",
    module: "Emergency Exit",
    violation: "Blockage",
    violationArea: "",
    image:
      "https://plus.unsplash.com/premium_photo-1663040345603-fe0968d5d514?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Y29uc3RydWN0aW9uJTIwd29ya2VyfGVufDB8fDB8fHww", // Replace with the actual image path
  },
  {
    camera: "5",
    date: "2024-09-12",
    time: "10:20 AM",
    VioSeverity: "Low",
    status: "In Active",
    module: "Machine Guard",
    violation: "Door Open",
    violationArea: "",
    image:
      "https://plus.unsplash.com/premium_photo-1663040345603-fe0968d5d514?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Y29uc3RydWN0aW9uJTIwd29ya2VyfGVufDB8fDB8fHww", // Replace with the actual image path
  },
  {
    camera: "5",
    date: "2024-09-12",
    time: "10:20 AM",
    VioSeverity: "Low",
    status: "In Active",
    module: "Machine Guard",
    violation: "Door Open",
    violationArea: "",
    image:
      "https://plus.unsplash.com/premium_photo-1663040345603-fe0968d5d514?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Y29uc3RydWN0aW9uJTIwd29ya2VyfGVufDB8fDB8fHww", // Replace with the actual image path
  },
];

export const tableColumnsForArea = [
  {
    name: "Sr.",
    selector: (row) => row.id,
    // sortable: true,
  },

  {
    name: "Violation severity",
    selector: (row) => row.VioSeverity,
    // sortable: true,
  },

  {
    name: "Module",
    selector: (row) => row.module,
    // sortable: true,
  },
  {
    name: "Violation",
    selector: (row) => row.violation,
    // sortable: true,
  },
  {
    name: "Violation Area",
    selector: (row) => row.violationArea,
    // sortable: true,
  },
  {
    name: "Camera Name",
    selector: (row) => row.camera_name,
    // sortable: true,
  },
  {
    name: "Date",
    selector: (row) => row.date,
    sortable: true,
    sortFunction: (a, b) => new Date(b.date) - new Date(a.date),
  },
  {
    name: "Time",
    selector: (row) => row.time,
    sortable: true,
    sortFunction: (a, b) => {
      // First, compare by date in descending order
      const dateComparison = new Date(b.date) - new Date(a.date);
      if (dateComparison !== 0) return dateComparison;

      // If dates are the same, compare by time in descending order (AM/PM format)
      const convertTo24HourFormat = (timeStr) => {
        const [time, modifier] = timeStr.split(" "); // e.g., "02:30 PM" becomes ["02:30", "PM"]
        let [hours, minutes] = time.split(":").map(Number);

        // Convert hours to 24-hour format
        if (modifier === "PM" && hours !== 12) {
          hours += 12;
        } else if (modifier === "AM" && hours === 12) {
          hours = 0;
        }

        return { hours, minutes };
      };

      // Convert both times to 24-hour format
      const { hours: hoursA, minutes: minutesA } = convertTo24HourFormat(
        a.time
      );
      const { hours: hoursB, minutes: minutesB } = convertTo24HourFormat(
        b.time
      );

      // Compare by hours and minutes in descending order
      return hoursB - hoursA || minutesB - minutesA;
    },
  },
  {
    name: "Image",
    cell: (row) => (
      <img
        src={row.image}
        alt="Violation"
        style={{
          width: "70px",
          height: "50px",
          borderRadius: "10px",
          marginBlock: "10px",
        }}
      />
    ),
  },
];

export const allCamerasData = [
  {
    id:'01',
    camera: "Camera 1",
    nvr:'DHI-NVR 05',
    cameraIP:'192.168.10.213',
    subArea: 'Ammonia Compressor Room',
    cameraId: 'ICF-SA2-ACR-1-05-213 ',
    date: "2024-09-13",
    status: "Active",
    module: "Emergency Exit",
    image:
      "https://www.linde-mh.it/media/Global-Content/03_Solutions_Loesungen/Applications/interactive-warning-vest-6419_16x9w1920.jpg", // Replace with the actual image path
  },
  {
    id:'02',
    camera: "Camera 2",
    nvr:'DHI-NVR5',
    cameraIP:'192.168.10.220',
    subArea: 'Ammonia Compressor Room',
    cameraId: 'ICF-SA2-ACR-2-5-220',
    date: "2024-09-12",
    status: "In Active",
    module: "Machine Guard",
    image:
    "https://www.linde-mh.it/media/Global-Content/03_Solutions_Loesungen/Applications/interactive-warning-vest-6419_16x9w1920.jpg",
  },
  {
    id:'03',
    camera: "Camera 3",
    nvr:'DHI-NVR5',
    cameraIP:'192.168.10.221',
    subArea: 'Ammonia Compressor Room',
    cameraId: 'ICF-SA2-ACR-3-5-221',
    date: "2024-09-12",
    status: "In Active",
    module: "Machine Guard",
    image:
      "https://www.linde-mh.it/media/Global-Content/03_Solutions_Loesungen/Applications/interactive-warning-vest-6419_16x9w1920.jpg",
  },
  {
    id:'04',
    camera: "Camera 4",
    nvr:'DHI-NVR5',
    cameraIP:'192.168.10.222',
    subArea: 'Ammonia Compressor Room',
    cameraId: 'ICF-SA2-ACR-4-5-222',
    date: "2024-09-12",
    status: "In Active",
    module: "Machine Guard",
    image:
      "https://www.linde-mh.it/media/Global-Content/03_Solutions_Loesungen/Applications/interactive-warning-vest-6419_16x9w1920.jpg",
  },
  {
    id:'05',
    camera: "Camera 5",
    nvr:'DHI-NVR5',
    cameraIP:'192.168.10.223',
    subArea: 'Ammonia Compressor Room',
    cameraId: 'ICF-SA2-ACR-5-5-223',
    date: "2024-09-12",
    status: "Active",
    module: "Helmet Module",
    image:
      "https://www.linde-mh.it/media/Global-Content/03_Solutions_Loesungen/Applications/interactive-warning-vest-6419_16x9w1920.jpg",
  },
  {
    id:'06',
    camera: "Camera 6",
    nvr:'DHI-NVR5',
    cameraIP:'192.168.10.225',
    subArea: 'Ammonia Compressor Room',
    cameraId: 'ICF-SA2-ACR-6-5-225',
    date: "2024-09-12",
    status: "Active",
    module: "Helmet Module",
    image:
      "https://www.linde-mh.it/media/Global-Content/03_Solutions_Loesungen/Applications/interactive-warning-vest-6419_16x9w1920.jpg",
  },
  {
    id:'07',
    camera: "Camera 7",
    nvr:'DHI-NVR5',
    cameraIP:'192.168.10.226',
    subArea: 'Ammonia Compressor Room',
    cameraId: 'ICF-SA2-ACR-7-5-226',
    date: "2024-09-12",
    status: "Active",
    module: "Helmet Module",
    image:
      "https://www.linde-mh.it/media/Global-Content/03_Solutions_Loesungen/Applications/interactive-warning-vest-6419_16x9w1920.jpg",
  },
  {
    id:'08',
    camera: "Camera 8",
    nvr:'DHI-NVR2',
    cameraIP:'192.168.10.81',
    subArea: 'Ref workshop',
    cameraId: 'ICF-SA2-RW-1-2-81',
    date: "2024-09-12",
    status: "Active",
    module: "Helmet Module",
    image:
      "https://www.linde-mh.it/media/Global-Content/03_Solutions_Loesungen/Applications/interactive-warning-vest-6419_16x9w1920.jpg",
  },
  {
    id:'09',
    camera: "Camera 9",
    nvr:'DHI-NVR8',
    cameraIP:'192.168.9.52',
    subArea: 'Ref workshop',
    cameraId: 'ICF-SA2-RW-2-8-52',
    date: "2024-09-12",
    status: "Active",
    module: "Helmet Module",
    image:
      "https://www.linde-mh.it/media/Global-Content/03_Solutions_Loesungen/Applications/interactive-warning-vest-6419_16x9w1920.jpg",
  },
  {
    id:'10',
    camera: "Camera 10",
    nvr:'DHI-NVR2',
    cameraIP:'192.168.10.79',
    subArea: 'Ref Control Room',
    cameraId: 'ICF-SA2-RCR-1-2-79',
    date: "2024-09-12",
    status: "Active",
    module: "Helmet Module",
    image:
      "https://www.linde-mh.it/media/Global-Content/03_Solutions_Loesungen/Applications/interactive-warning-vest-6419_16x9w1920.jpg",
  },
  {
    id:'11',
    camera: "Camera 10",
    nvr:'DHI-NVR8',
    cameraIP:'192.168.9.51',
    subArea: 'Ref Control Room',
    cameraId: 'ICF-SA2-RCR-2-8-51',
    date: "2024-09-12",
    status: "Active",
    module: "Helmet Module",
    image:
      "https://www.linde-mh.it/media/Global-Content/03_Solutions_Loesungen/Applications/interactive-warning-vest-6419_16x9w1920.jpg",
  },
];

export const allCamerasColumns = [
  {
    name: "Sr.",
    selector: (row) => row.id,
    width: "50px",
    // sortable: true,
  },
  {
    name: "Camera Name",
    selector: (row) => row.camera,
    // sortable: true,
  },

  {
    name: "Module",
    selector: (row) => row.module,
    // sortable: true,
  },
  {
    name: "Status",
    selector: (row) => row.status,
    // sortable: true,
  },
  {
    name: "Date",
    selector: (row) => row.date,
    sortable: true,
    sortFunction: (a, b) => new Date(b.date) - new Date(a.date),
  },
 
  {
    name: "Image",
    cell: (row) => (
      <img
        src={row.image}
        alt="Violation"
        style={{
          width: "70px",
          height: "50px",
          borderRadius: "10px",
          marginBlock: "10px",
        }}
      />
    ),
  },
];
